import { NOTIFICATIONS } from "consts/notifications";

export enum Referral {
  IsReferralBonus = "isReferralBonus",
  BonusForInvitee = "bonusForInvitee",
  BonusForInviter = "bonusForInviter",
  ReferralBonusPercent = "referralBonusPercent",
  ReferralBonusThreshold = "referralBonusThreshold",
  BonusReferralsCountRequired = "bonusReferralsCountRequired",
}

export type StateValues = {
  [Referral.IsReferralBonus]: undefined | boolean;
  [Referral.BonusForInvitee]: undefined | number;
  [Referral.BonusForInviter]: undefined | number;
  [Referral.ReferralBonusPercent]: undefined | number;
  [Referral.ReferralBonusThreshold]: undefined | number;
  [Referral.BonusReferralsCountRequired]: undefined | number;
};

export const initialState: StateValues = {
  [Referral.IsReferralBonus]: undefined,
  [Referral.BonusForInvitee]: undefined,
  [Referral.BonusForInviter]: undefined,
  [Referral.ReferralBonusPercent]: undefined,
  [Referral.ReferralBonusThreshold]: undefined,
  [Referral.BonusReferralsCountRequired]: undefined,
};

export type LoadingStateValues = Record<keyof StateValues, boolean>;

export const initialLoadingState: LoadingStateValues = {
  [Referral.IsReferralBonus]: false,
  [Referral.BonusForInvitee]: false,
  [Referral.BonusForInviter]: false,
  [Referral.ReferralBonusPercent]: false,
  [Referral.ReferralBonusThreshold]: false,
  [Referral.BonusReferralsCountRequired]: false,
};

export type ConfirmReferralModalType = {
  key: Referral;
  value: boolean | number;
};

export const notificationMessage = {
  [Referral.IsReferralBonus]: NOTIFICATIONS.IS_REFERRAL_BONUS,
  [Referral.BonusForInvitee]: NOTIFICATIONS.REFERRAL_BONUS,
  [Referral.ReferralBonusThreshold]: NOTIFICATIONS.REFERRER_BONUS,
  [Referral.BonusForInviter]: NOTIFICATIONS.REFERRER_BONUS,
  [Referral.ReferralBonusPercent]: NOTIFICATIONS.REFERRAL_BONUS,
  [Referral.BonusReferralsCountRequired]: NOTIFICATIONS.IS_REFERRAL_BONUS,
};
